import { Button as MUIButton } from "@mui/material";
import { createLink } from "@tanstack/react-router";

const RouterButton = createLink(MUIButton);

export default RouterButton;
